<template>
    <div class="topbar-container">
        <zbView
            @reLoad="userLoginend"
            emptyMessage="本车辆暂无违章信息"
            class="break-list"
            :isEmpty="!store.length"
        >
            <div v-for="(item,i) in store" :key="i" class="list-item">
                <div class="line"></div>
                <div class="item">
                    <div class="bh bc fz_28 text-container">
                        <i class="icon ico-time-brerk bg-contain"></i>
                        <div class="b1">{{item.vioTime}}</div>
                        <span class="c_666">{{item.vioStatus}}</span>
                    </div>
                    <div class="fz_30 p30_0">{{item.vioLocation}}</div>
                    <div class="fz_24 c_666">{{item.vioReason}}</div>
                    <div class="pt30 fz_30 c_warning">罚款{{item.vioFine}}元&emsp;扣{{item.degree}}分</div>
                </div>
            </div>
        </zbView>
    </div>
</template>
<script>
import { user } from "@/mixin/user";
import { routeCache } from "@/mixin/cache";
import { breakHistory } from "@/api/break";
import zbView from "@/components/data/View";
export default {
    mixins: [user, routeCache],
    name: "BreakHistory",
    components: { zbView },
    data() {
        return {
            store: []
        };
    },
    methods: {
        userLoginend() {
            const me = this,
                params = me.getCache();
            breakHistory({
                cusCarId: params.id
            }).then(res => {
                me.setData(res.data);
            });
        },
        setData(data) {
            this.store = data;
        }
    }
};
</script>